import { useEffect, useState } from 'react';

/**
 * Live viewport height in px. Drives JS-side sizing that must follow the
 * same short-viewport scaling the stage CSS does with `svh` units — e.g.
 * the winner title's font cap (see stageLayout.ts).
 */
export function useViewportHeight(): number {
  const [height, setHeight] = useState(() => window.innerHeight);

  useEffect(() => {
    const onResize = () => setHeight(window.innerHeight);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return height;
}
